import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-editusuariomodal',
    standalone: true,
    templateUrl: './editusuariomodal.component.html',
    styleUrls: ['./editusuariomodal.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatButton]
})
export class EditusuariomodalComponent implements OnInit {

  formData: FormGroup;
  usuarioCliente: any;

  constructor(public dialogRef: MatDialogRef<EditusuariomodalComponent>, private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.formData = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      apellidoP: ['', [Validators.required]],
      apellidoM: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
